import { z } from 'zod';
import { DocTypeSchema, ExportFormatSchema } from '../enums.js';
import { IdSchema, IsoDateTimeSchema } from './common.js';
export const RequestExportInputSchema = z.object({
    docType: z.union([DocTypeSchema, z.literal('tasks'), z.literal('timeline')]),
    format: ExportFormatSchema,
    versionId: IdSchema.optional(),
});
/** projects/{id}/exports/{id} */
export const ExportRecordSchema = z.object({
    id: IdSchema,
    docType: z.union([
        DocTypeSchema,
        z.literal('tasks'),
        z.literal('timeline'),
        z.literal('training'),
    ]),
    format: z.union([ExportFormatSchema, z.literal('pptx')]),
    /** docType 'training' only: the one session exported, or unset for the whole training. */
    trainingSessionId: IdSchema.optional(),
    sourceVersionId: IdSchema.nullable().default(null),
    storagePath: z.string(),
    generatedAt: IsoDateTimeSchema,
    generatedByUid: IdSchema,
});
//# sourceMappingURL=export.js.map